import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {ConceptRelationService} from '@twpub/core/services/concept-relation.service';
import {ConceptRelation, ConceptSelection} from '@twpub/core/models';

import {RenderRelationComponent} from '../render-relation/render-relation.component';

@Component({
  selector: 'pub-render-relations',
  templateUrl: './render-relations.component.html',
  styleUrls: ['./render-relations.component.scss'],
  standalone: true,
  imports: [RenderRelationComponent]
})
export class RenderRelationsComponent implements OnInit, OnChanges {
  @Input() conceptId?: number;
  @Input() textComponent: boolean = false;

  @Output() conceptSelected = new EventEmitter<ConceptSelection>();

  relations: ConceptRelation[] = [];

  constructor(private relationService: ConceptRelationService) {
  }

  ngOnInit(): void {
    this.initRelations();
  }

  ngOnChanges(): void {
    this.initRelations()
  }

  isReversed = (relation: ConceptRelation): boolean => relation.targetConceptId === this.conceptId;

  private initRelations() {
    if (this.conceptId) {
      this.relationService.getRelationsForConcept(this.conceptId).subscribe(relations => {
        this.relations = relations;
      });
    } else {
      this.relations = []
    }
  }

  selectConcept(selection: ConceptSelection) {
    this.conceptSelected.emit(selection);
  }
}
